import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@stores/auth/authStore";
import { canAccessPlatformPermission, hasExactPermission } from "@lib/permissions";

export const PermissionRoute: React.FC<{
    permission: string;
    /** Require the literal permission; wildcard grants (owner `*`) do not qualify. */
    exact?: boolean;
    children: React.ReactNode;
}> = ({ permission, exact = false, children }) => {
    const permissions = useAuthStore((s) => s.permissions);
    const allowed = exact
        ? hasExactPermission(permissions, permission)
        : canAccessPlatformPermission(permissions, permission);
    if (!allowed) {
        return <Navigate to="/" replace />;
    }
    return <>{children}</>;
};
